import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist'
import {
  OrdersTableSortProps,
  OrdersTableSearchProps
} from './orders-table-base.types'

export const initialOrdersTablePaginationProps: PaginationProps<OrdersTableSortProps> = {
    page: 0,
    size: 15,
    sortDirection: SortDirection.DESC,
    sortProp: OrdersTableSortProps.NUMBER,
    totalElements: 0,
    totalPages: 0
}

export const initialOrdersTableSearchProps: OrdersTableSearchProps = {
    customerId: null,
    maxAmount: null,
    maxDate: null,
    minAmount: null,
    minDate: null,
    number: null,
    status: null,
    store: null,
    firstName: null
}

export const ordersNeedTimeoutProps: Array<keyof OrdersTableSearchProps> = [
    "number"
]
